import { UlItem } from '../../../../models/ui.interfaces';
import {
  ImageListEntity,
  MedallionEntity,
  NavigationEntity,
  PopularTopicsEntity,
  SalutationEntity,
  WaiverEntity
} from './header.entity.interfaces';

/** Holds content that display on "NOTIFICATION ICON" auxiliary navigation on header */
export interface NotificationNavigation {
  feedLabel?: string | null;
  advisioriesLabel?: string | null;
  advisoriesViewAllLabel?: string | null;
  advisioriesViewAllLink?: string | null;
  advisoriesViewNewWindow?: string | null;
  newsLabel?: string | null;
  newsViewAllLabel?: string | null;
  newsViewAllLink?: string | null;
  newsViewNewWindow?: string | null;
  notificationLabel?: string | null;
  notificationViewAllLabel?: string | null;
  notificationViewAllLink?: string | null;
  notificationViewNewTab?: string | null;
}

/** Holds content that display on "PROFILE" selector auxiliary navigation on header */
export interface ProfileSelectorNavigation {
  acPickerLogo?: string | null;
  chooseAccountDisplayText?: string | null;
  chooseAccountDisclaimer?: string | null;
  businessLoginDisplayText?: string | null;
  personalLoginDisplayText?: string | null;
  businessTravelerDisplayText?: string | null;
  personalTravelerDisplayText?: string | null;
  CRG3?: string | null;
  BBIZ?: string | null;
  CRAM?: string | null;
  SKYB?: string | null;
  adminLoginDisplayText?: string | null;
  adminLoginUrl?: string | null;
  nuTravelAdminLoginUrl?: string | null;
  logOutDisplayText?: string | null;
  businessLogoutUrl?: string | null;
  loginAccountPickerText?: string | null;
}

/** Holds all Auxilary Navigation content of header E.g., "SIGN-UP", "LOGIN", "CONTUCT US", "NOTIFICATION", "SEARCH FEED" */
export interface AuxiliaryNavigationEntity
  extends NavigationEntity,
    NotificationNavigation,
    ProfileSelectorNavigation {
  rightnavLabel?: string | null;
  rightnavLink?: string | null;
  loggedInMilesLabel?: string | null;
  loggedInMilesLabelBusiness?: string | null;
  contactUsLabel?: string | null;
  contactUsUrl?: string | null;

  businessLogo?: string | null;
  acSwitchText?: string | null;
  acSwitchGenericText?: string | null;
  progressImageUrl?: string | null;
  imageList?: ImageListEntity[] | null;
  noResultText?: string | null;
  searchLabel?: string | null;
  searchFloatingLabel?: string | null;
  popularLabel?: string | null;
  popularTopics?: PopularTopicsEntity[] | null;
  skymilesMember?: string | null;
  statusLabel?: string | null;
  gateLabel?: string | null;
  seatLabel?: string | null;
  checkinLabel?: string | null;
  checkinOpenNewTab?: string | null;
  viewBoardingPass?: string | null;
  viewBoardingPassOpenNewTab?: string | null;
  bookFlightLink?: string | null;
  myTripsLink?: string | null;
  depart?: string | null;
  arrive?: string | null;
  operatedby?: string | null;
  was?: string | null;
  remainOnFlight?: string | null;
  findAlternate?: string | null;
  findAlternateOpenNewTab?: string | null;
  viewTripDetails?: string | null;
  viewTripDetailsOpenNewTab?: string | null;
  arrowFlightDetailsOpenNewTab?: string | null;
  myFlightLabel?: string | null;
  todayLabel?: string | null;
  feed?: string | null;
  skymilesLabel?: string | null;
  availableMilesLabel?: string | null;
  milesNeverExpire?: string | null;
  medellionStatusDisclaimer?: string | null;
  thankYouMessage?: string | null;
  mqmLabel?: string | null;
  mqmAccessibilityLabel?: string | null;
  mqsLabel?: string | null;
  mqsAccessibilityLabel?: string | null;
  mqdLabel?: string | null;
  mqdAccessibilityLabel?: string | null;
  cardSpendAccessibility?: string | null;
  miles?: string | null;
  segments?: string | null;
  cardSpendLabel?: string | null;
  to?: string | null;
  goTo?: string | null;
  currencySymbol?: string | null;
  mqdWaiver?: string | null;
  medellionStatusDisclaimer2?: string | null;
  logoutLabel?: string | null;
  logoutUrl?: string | null;
  sinceLabel?: string | null;
  accountOverview?: string | null;
  accountDetails?: string | null;
  status?: string | null;
  myFlightCaretUrl?: string | null;
  myFlightCaretOpenNewTab?: string | null;
  medallion?: (UlItem & MedallionEntity)[] | null;
  waiver?: WaiverEntity[] | null;
  salutation?: SalutationEntity[] | null;
  dashboardLabel?: string | null;
  dashboardUrl?: string | null;
  dashboardOpenInNewWindow?: string | null;
  profileLabel?: string | null;
  profileUrl?: string | null;
  profileOpenInNewWindow?: string | null;
  thankYouMessageMember?: string | null;
}
